module.exports = __webpack_public_path__ + "static/media/library.d5def983.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/library.png
// module id = 7474
// module chunks = 0